export enum EProgressItemsActionType {
  REMOVE_PROGRESS_ITEM = 'PROGRESS/REMOVE_ITEM',
  UPDATE_OR_ADD_PROGRESS_ITEM = 'PROGRESS/UPDATE_OR_ADD_ITEM',
}
